import React from 'react';
import urls from '../configs/urls'
import { Redirect } from 'react-router'
import '../css/App.css';
import ls from 'local-storage'
import axios from 'axios';
import city from '../images/city.png'
import Loading from "./Loading";

class CityChoose extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            loading: true,
            is_chosen : false,
            cities:[],
        };
    }
    componentWillMount = () => {
        this.getCities();
    };

    citiesList() {
        return this.state.cities.map((data,index) => {
            return (
                <div className="city_name" onClick={()=>this.setCity(index)}>
                    <p style={{position:"relative", width:"90%",textAlign:"right",margin:"15px 15px 15px"}}>{data.city_name}</p>
                </div>
            )
        });
    }

    render() {
        if(this.state.is_chosen)
            return (<Redirect to='/'/>);
        return (

            <div className="App">
                <Loading loading={this.state.loading}/>
                <header className="App-body bg-white" style={{position:"relative"}}>
                    <h3 style={{position:"absolute",top:"0",width:"100%",textAlign:"center"}}>انتخاب شهر</h3>
                    <h6 style={{position:"absolute",top:"40px",width:"100%",color:"gray",fontSize:"1rem"}}>لطفا شهر محل سکونت خود را انتخاب کنید</h6>
                    <div style={{position:"absolute",top:"130px",color:"gray",width:"100%",marginRight:"10px"}}>{this.citiesList()}</div>
                    <img src={city} style={{position:"absolute",bottom:"0",width:"100%",left:0}}/>
                </header>
            </div>
        );
    }
    setCity(index){
        this.setState({loading:true});
        if(!ls.get("token")){
            ls.set("city_id",this.state.cities[index]['id']);
            ls.set("city_name",this.state.cities[index]['city_name']);
            this.setState({is_chosen:true});
            return;
        }
        let data = {
            token:ls.get("token"),
            city_id:this.state.cities[index]['id']
        };
        axios.post(urls.baseUrl+urls.setCity,data)
            .then(res => {
                console.log("City : ",res.data);
                if(res.data.code == 200){
                    ls.set("city_id",this.state.cities[index]['id']);
                    ls.set("city_name",this.state.cities[index]['city_name']);
                    this.setState({is_chosen:true,loading:false});
                }
            })
    }
    getCities(){
        axios.get(urls.baseUrl+urls.getCities)
            .then(res => {
                if(res.data.code == 200){
                    const cities = res.data.cities;
                    ls.set("cities",cities);
                    this.setState({cities:cities,loading:false});
                }
            })
    }
}



export default CityChoose;
